import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigation } from "./components";
import ScrollToTop from "./components/ScrollTop";
import DashboardPage from "./pages/DashboardPage";
import AllEducationCertificates from "./pages/EducationPage";
import ProjectPage from "./pages/ProyectPage";
import "./index.scss";

function App() {
  const [mode, setMode] = useState<string>("dark");

  const handleModeChange = () => {
    setMode((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <Router>
      <ScrollToTop /> 
      <div className={`main-container ${mode === "dark" ? "dark-mode" : "light-mode"}`}>
        <Navigation parentToChild={{ mode }} modeChange={handleModeChange} />
        <Routes>
          <Route path="/" element={<DashboardPage mode={mode} />} />
          <Route path="/education" element={<AllEducationCertificates />} />
          <Route path="/projects" element={<ProjectPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
